export default {
  language: {
    policy: '隐私政策',
    user: '用户协议',
    withdrawal: '撤回同意'
  },
  provacy: {
    title: '隐私协议',
    updateTime: '修改日期：2024年12月27日',
    effectiveTime: '生效日期：2024年12月27日',
    preface1: '云天智能信息（深圳）有限公司（以下简称“云天”或“我们”）非常重视您的隐私和个人信息保护。您在使用我们的相关服务时，我们可能会处理您的个人信息。我们希望通过本《隐私政策》（以下简称“本政策”）向您说明，在使用我们的服务时，我们收集您的哪些个人信息，我们如何处理这些信息，以及我们为您提供的行使您的信息权利的方式。',
    preface2: `我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请在使用我们的产品或服务前，仔细阅读并了解本《隐私政策》。
    我们会定期更新我们的软件应用，以便做出改进。为了确保本隐私政策准确反映您对服务的使用情况，您需要确保您正在使用最新版本的云天软件应用。您需理解，只有在您确认并同意变更后的《隐私政策》，我们才会依据变更后的隐私政策收集、使用、处理和存储您的个人信息；您有权拒绝同意变更后的隐私政策，但请您知悉，一旦您拒绝同意变更后的隐私政策，可能导致您不能或不能继续完整使用云天的相关服务和功能，或者无法达到我们拟达到的服务效果。`,
    main_title1: '一、我们如何收集和使用您的个人信息',
    main_title1_no1_title: '（一）通常情况下，我们仅会在以下场景中收集您的个人信息：',
    main_title1_no1_text1: `使用云天的产品或服务`,
    main_title1_no1_text2: `在您使用云天的产品或服务的过程中，为了保证云天产品和服务相应功能的正常实现，您可能需要向我们提供您的以下信息：`,
    main_title1_no1_text2_1: `- 您购买的云天产品的序列号`,
    main_title1_no1_text2_2: `- 授予我方访问您手机的存储权限获取外置存储信息（手机的视频及照片、SD卡数据等）`,
    main_title1_no1_text2_3: `- 您设备的地理位置信息`,
    main_title1_no1_text2_4: `- 设备的硬件型号`,
    main_title1_no1_text2_5: `- 操作系统版本号`,
    main_title1_no1_text2_6: `- 传感器信息（加速度传感器）`,
    main_title1_no1_text2_7: `- 设备标识符（Android如设备序列号、IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA、SN；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）`,
    main_title1_no1_text2_8: `- 获取手机应用安装列表等`,
    main_title1_no1_text3_1: `我们也可以能收集网络设备硬件地址（MAC地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、SIM卡序列号等。`,
    main_title1_no1_text3_2: `您设备的地理环境和位置信息、设备的配置信息、分享的文字或图片，其他数据（包括传感器数据、导航系统数据、设备数据、控制类数据、环境感知视觉数据）等，我们也可能收集您的产品使用日志记录、接入我们产品或服务的 IP地址、时间信息等。`,
    main_title1_no1_text3_3: `如果您拒绝提供此类信息，我们将无法为您提供相应的服务，但不会影响您使用云天产品和服务的其他功能。`,

    main_title1_no2_title: '（二）我们如何使用个人信息：',
    main_title1_no2_text1: '云天将收集的个人数据用于以下目的：',
    main_title1_no2_text2: '1. 产品功能体验提升',
    main_title1_no2_text2_1: '如本政策所讨论的，我们将利用信息了解用户如何与我们的功能和服务互动，提供更优质的内容，同时改进云天用户的产品体验，开展研究和分析。',
    main_title1_no2_text3: '2. 业务运营',
    main_title1_no2_text3_1: '我们将收集的信息用于各种业务运营，例如：检测安全事件，防止恶意、欺骗性、欺诈性或非法活动的发生，并对此类活动的责任人提出起诉；维护您的帐户；以及调试以识别和修复对服务造成损害的错误。',
    main_title1_no2_text4: '3. 优质功能服务',
    main_title1_no2_text4_1: '我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于给您提供更加优质的功能使用，例如让您拥有更广泛的社交圈的需要而使用、共享或披露。',
    main_title1_no2_text5: '在以下情形，我们有权收集、使用您的个人信息而无需征得您的授权同意：',
    main_title1_no2_text5_1: '1. 与国家安全、国防安全有关的；',
    main_title1_no2_text5_2: '2. 与公共安全、公共卫生、重大公共利益有关的；',
    main_title1_no2_text5_3: '3. 与刑事侦查、起诉、审判和判决执行等有关的；',
    main_title1_no2_text5_4: '4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；',
    main_title1_no2_text5_5: '5. 所收集的个人信息是您自行向社会公众公开的；',
    main_title1_no2_text5_6: '6. 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
    main_title1_no2_text5_7: '7. 根据您的要求签订合同所必需的；',
    main_title1_no2_text5_8: '8. 用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；',
    main_title1_no2_text5_9: '9. 为合法的新闻报道所必需的；',
    main_title1_no2_text5_10: '10. 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
    main_title1_no2_text5_11: '11. 与我们履行法律法规规定的义务相关的；',
    main_title1_no2_text5_12: '12. 法律法规规定的其他情形。',
    main_title1_no2_text6_1: '您的个人信息中可能含有个人敏感信息，例如您的种族、宗教信仰、个人健康状况、性别取向等，您在使用我们产品或服务时，您可能会在公开渠道上传或发布这类敏感信息。请您谨慎地处理这类个人敏感信息。',
    main_title1_no2_text6_2: '您提供的上述信息，将在您使用云天产品和服务期间持续授权我们使用。法律法规对信息的保存时间另有要求的，我们将遵守法律法规的规定。',
    main_title1_no2_text6_3: '上述信息将存储于中华人民共和国境内。如需跨境传输，我们将会按照法律法规的要求开展安全评估。',
    main_title1_no2_text6_4: '当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。',
    main_title1_no3_title: '（三）我们如何使用Cookies和同类技术',
    main_title1_no3_text1: '1. Cookie',
    main_title1_no3_text1_1: '为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好或购物篮内的商品等数据。',
    main_title1_no3_text1_2: '我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问各浏览器官方网站的介绍页面。',
    main_title1_no3_text2: '2. Cookie 同类技术',
    main_title1_no3_text2_1: '除 Cookie 外，我们还可能会在网站上使用网站信标和像素标签其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击 URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。',
    main_title1_no4_title: '（四）我们如何使用SDK',
    main_title1_no4_text1: '为提供和优化我们的服务，我们的App中可能内嵌了第三方的SDK。这些第三方SDK在配合我们向您提供更全面的服务的同时，可能会收集您的个人信息。我们将采取必要方式控制该等第三方SDK对您个人信息的收集与使用，确保您的个人信息得到有效保护。关于第三方的身份、收集目的以及第三方的隐私政策链接等，请详见',
    main_title1_no4_text1_src: '第三方SDK说明。',
    main_title2: '二、我们如何处理儿童的个人信息',
    main_title2_text1: '我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。',
    main_title2_text2: '对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。',
    main_title2_text3: '尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。',
    main_title2_text4: '如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。',
    main_title3: '三、我们如何共享、转让、公开披露您的个人信息',
    main_title3_no1_title: '（一）共享',
    main_title3_no1_text1: '我们不会与云天以外的任何公司、组织和个人分享您的个人信息， 但以下情况除外：',
    main_title3_no1_text2: '1. 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；',
    main_title3_no1_text3: '2. 我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息；',
    main_title3_no1_text4: '3. 与我们的附属公司共享：您的个人信息可能会与我们的附属公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。附属公司如要改变个人信息的处理目的，将再次征求您的授权同意；',
    main_title3_no1_text5: '4. 与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您上网购买我们的产品时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。',
    main_title3_no1_text6: '目前，云天的授权合作伙伴包括我们的供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、提供交易及通信服务（如支付、物流、短信、邮件服务等）、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查等。',
    main_title3_no1_text7: '对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。',
    main_title3_no2_title: '（二）转让',
    main_title3_no2_text1: '我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
    main_title3_no2_text2: '1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；',
    main_title3_no2_text3: '2. 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。',
    main_title3_no3_title: '（三）公开披露',
    main_title3_no3_text1: '我们仅会在以下情况下，公开披露您的个人信息：',
    main_title3_no3_text2: '1. 获得您明确同意后；',
    main_title3_no3_text3: '2. 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。',
    main_title4: '四、我们如何保护您的个人信息',
    main_title4_no1: '（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与 “服务”之间交换数据（如信用卡信息）时受SSL加密保护；我们对云天官网提供了 https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们设立了个人信息保护专职部门；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。',
    main_title4_no2: '（二）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。',
    main_title4_no3: '（三）互联网并非绝对安全的环境，而且电子邮件、即时通讯及与其他云天用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。',
    main_title4_no4: '（四）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。',
    main_title4_no5: '（五）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。',
    main_title5: '五、您的权利',
    main_title5_text1: '按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法， 我们保障您对自己的个人信息行使以下权利：',
    main_title5_no1_title: '（一）访问您的个人信息',
    main_title5_no1_text1: '您有权根据法律法规的规定访问您的个人信息。如果您想行使数据访问权，可以通过以下方式自行访问：',
    main_title5_no1_text2: '账户信息 ——如果您希望访问或编辑您的账户中的个人资料信息和支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过访问我们网站或应用中的个人资料、修改密码等相关页面执行此类操作。但出于安全性和身份识别的考虑或根据法律法规的强制规定，您可能无法修改注册时提供的初始注册信息。',
    main_title5_no1_text3: '如果您无法通过上述方式访问这些个人信息，您可以随时发送电子邮件至donglinhui@ytznxx.com，或根据网站或应用中提供的方式与我们联系。',
    main_title5_no2_title: '（二）更正您的个人信息',
    main_title5_no2_text1: '当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以随时发送电子邮件至 donglinhui@ytznxx.com，或根据网站或应用中提供的方式与我们联系。',
    main_title5_no3_title: '（三）删除您的个人信息',
    main_title5_no3_text1: '在以下情形中，您可以向我们提出删除个人信息的请求：',
    main_title5_no3_text2: '1. 如果我们处理个人信息的行为违反法律法规；',
    main_title5_no3_text3: '2. 如果我们收集、使用您的个人信息，却未征得您的同意；',
    main_title5_no3_text4: '3. 如果我们处理个人信息的行为违反了与您的约定；',
    main_title5_no3_text5: '4. 如果我们不再为您提供产品或服务。',
    main_title5_no3_text6: '若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。',
    main_title5_no3_text7: '当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。',
    main_title5_no4_title: '（四）改变您授权同意的范围',
    main_title5_no4_text1: '每个业务功能需要一些基本的个人信息才能得以完成（见本政策 “第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。',
    main_title5_no4_text2: '您可以通过以下方式自行操作：',
    main_title5_no4_text2_1: '通过访问我们网站或应用的授权页面，对您个人信息的授权同意情况进行重新设置。',
    main_title5_no4_text2_2: '当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。',
    main_title5_no4_text2_3: '如果您不想接受我们给您发送的商业广告，您随时可通过我们在邮件或短信中提供的方式退订。',
    main_title5_no5_title: '（五）约束信息系统自动决策',
    main_title5_no5_text1: '在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。',
    main_title5_no6_title: '（六）响应您的上述请求',
    main_title5_no6_text1: '为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。',
    main_title5_no6_text2: `如您不满意，还可以向网信、电信、公安及工商等监管部门进行投诉或举报。
    对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。`,
    main_title5_no6_text3: '在以下情形中，按照法律法规要求，我们将无法响应您的请求：',
    main_title5_no6_text3_1: '1. 与国家安全、国防安全直接相关的；',
    main_title5_no6_text3_2: '2. 与公共安全、公共卫生、重大公共利益直接相关的；',
    main_title5_no6_text3_3: '3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；',
    main_title5_no6_text3_4: '4. 有充分证据表明您存在主观恶意或滥用权利的；',
    main_title5_no6_text3_5: '5. 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；',
    main_title5_no6_text3_6: '6. 涉及商业秘密的。',
    main_title6: '六、您的个人信息如何在全球范围转移',
    main_title6_text1: '原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。',
    main_title6_text2: '由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，您的个人信息可能会被转移到您使用产品或服务所在国家 /地区的境外管辖区，或者受到来自这些管辖区的访问。我们在转移前将根据法律法规的要求进行安全评估。',
    main_title6_text3: '此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。',
    main_title7: '七、本政策如何更新',
    main_title7_text1: '我们的隐私政策可能变更。我们会在本页面上发布对本政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知。',
    main_title7_text2: '本政策所指的重大变更包括但不限于：',
    main_title7_text2_1: '1. 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；',
    main_title7_text2_2: '2. 个人信息共享、转让或公开披露的主要对象发生变化；',
    main_title7_text2_3: '3. 您参与个人信息处理方面的权利及其行使方式发生重大变化。',
    main_title7_text3: '如您在本政策更新生效后继续使用云天的产品和服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。',
    main_title8: '八、联系我们',
    main_title8_text1: '如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过以下方式与我们联系：',
    main_title8_text2_1: '名 称：云天智能信息（深圳）有限公司',
    main_title8_text2_2: '联系地址：深圳市宝安区西乡街道固兴社区航城大道华丰国际机器人福森产业园B栋三层',
    main_title8_text2_3: '联系电话：18535710511',
    main_title8_text3: '为了保障安全，当您联系我们时，我们可能需要先验证您的身份信息，且将在接到您的请求并确认您的身份后15天内回复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。',
    main_title8_text4: '如果您对我们的答复或处理方式不满意，您可以通过以下外部途径寻求解决方式：向网信、工信、工商、消费者协会等机构进行投诉、举报，或向被告住所地有管辖权的人民法院提起诉讼。',
  },
  agree: {
    title: 'Openice 用户协议',
    updateTime: '修改日期：2024年10月23日',
    effectiveTime: '生效日期：2024年10月23日',
    preface1: '《用户协议》(以下简称“本协议”)是您(或称“用户”，指注册、登录、使用、浏览本服务的个人或组织)与云天智能信息（深圳）有限公司及其关联公司之间关于Openice 网站与产品、程序及服务所订立的协议(软件名称为Openice、软件开发商为云天智能信息（深圳）有限公司(以下简称我们))。',
    preface2: 'Openice在此特别提醒用户认真阅读、充分理解--本协议中各条款，包括免除或者限制Openice责任的免责条款及对用户的权利限制条款。请您审慎阅读并选择接受或不接受本协议(未成年人应在法定监护人陪同下阅读)。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉相关服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。',
    preface3: '您对本协议的接受即自愿接受全部条款的约束，包括接受我们对任一服务条款随时所做的任何修改。本协议可由我们随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本网站查阅最新版协议条款。在我们修改本协议相关条款之后，如果用户不接受修改后的条款，请立即停止使用我们提供的服务，用户继续使用我们提供的服务将被视为已接受了修改后的协议。',
    main_title1: '1.关于我们',
    main_title1_text: '“Openice”及相关技术与功能(以下合称为“本服务”)由云天智能信息（深圳）有限公司运营。本协议中的“您”与“用户”指任何使用和/或访问本服务的个人。',
    main_title2: '2.协议目的',
    main_title2_text1: '本用户协议及我们针对本服务发布其它服务条款、规则或提示(以下合称为“本协议”)是我们为您提供本服务以供使用及访问所依据的条款。通过本协议，您将了解我们、我们向您提供本服务的方式、本服务所允许及禁止的活动、应对问题的措施及其它重要信息。请您仔细阅读本协议，特别是涉及免除或者限制责任的条款、法律适用和争议解决条款等以加粗形式提示的重要内容。',
    main_title2_text2: '当您按照页面提示同意本协议或使用本服务，即视为您已与我们达成具有法律约束力的合同，我们将按照本协议约定履行相应的合同义务。若您不同意本协议，请勿使用本服务。',
    main_title2_text3: '若您对本协议存在任何疑问，您可通过“联系我们"章节中的联络信息联系我们。',
    main_title3: '3.使用本服务的要求',
    main_title3_text1: '您明确声明和保证:您具备足够的法律权利或授权来签署和履行本协议;您对于本协议的签署和履行不会对您须履行的任何其他协议、安排造成冲突或导致违约。如果您是未成年人(未满十八周岁)，在您决定是否使用本服务前，请您与父母或其他监护人一起阅读本协议以确保他们明确了解本协议内容,在获得父母或其他监护人同意之前，请勿使用本服务。特别地，如果您是儿童(未满十四周岁的未成年人)，在您使用我们的服务前，请务必通知您的父母或其他监护人一起仔细阅读本协议，并在您的父母或其他监护人同意或指导后，使用我们的服务或向我们提供信息。同时，我们建议父母或其他监护人对您的孩子使用互联网、手机和其他设备的行为进行合理的监督和指导。',
    main_title3_text2: '使用本服务要求您具备一台或多台与本服务兼容的终端设备，并完成无线移动数据服务网络连接。',
    main_title4: '4.访问本服务',
    main_title4_text1: '我们授予您依照本协议访问及使用本服务的有限的、非独家、不可转让、不可转授，但可撤销的许可。',
    main_title4_text2: '您需拥有Openice帐号才能访问或使用本服务。根据相关法律法规网络实名制的要求，您应当按照Openice帐号注册/登录页面的提示准确完整地提供您的信息。您了解并同意，您有义务保持您提供信息的真实性及有效性。有关Openice帐号详情，请打开Openice帐号，前往“我的”>“关于”>“Openice用户协议”进行了解。',
    main_title5: '5.本服务',
    main_title5_text1: '本服务包括以下服务内容：',
    main_title5_no1: '1.帐号登录：为了管理您的运动数据，需要您注册并登录Openice帐号。',
    main_title5_no2: '2.穿戴和运动设备管理：本服务支持管理您的Openice手环、手表等设备。通过蓝牙配对连接穿戴或设备，管理设备的使用、配置和升级，并从设备上获取您的运动数据，通过综合处理后进行展示。',
    main_title5_no3: '3.个人资料管理：本服务可编辑您的昵称、头像、性别、年龄、身高、体重以及个人设置相关信息，编辑后可保存在本地或我们云端。',
    main_title5_no4: '4.运动数据记录：本服务支持走路、跑步等日常运动数据和运动轨迹的记录和显示。',
    main_title5_no5: '5.数据管理：绑定穿戴设备后，本服务提供运动记录、睡眠、经期等相关数据的测量、记录和显示。',
    main_title5_no6: '6.成就体系：结合用户相关的运动数据、健身数据、大数据排名和周/月/年报服务，并以激励的形式为用户颁发虚拟勋章。',
    main_title5_no7: '7.用户体验改进服务：为改进产品质量并提升使用体验，需要您分享使用运动应用和配对连接设备的使用数据，包括您在应用中打开的页面和点击的按钮，应用和设备中功能运行情况，用来分析统计设备和应用的使用情况，改进用户使用体验。',
    main_title5_no8: '8.问题与建议:您使用过程中遇到的问题，可通过“问题与建议”上传日志进行反馈。',
    main_title5_no9: '9.线上活动:本服务提供线上挑战类、达标类活动，如果该活动由第三方服务商提供，需要您授权分享相应的运动数据。',
    main_title5_no10: '10.数据共享:本服务支持数据共享给QQ、微信、支付宝和Apple HealthKit等，在用户打开相应功能授权后，将运动和睡眠数据同步给相应应用，取消绑定后不再同步。',
    main_title6: '6.第三方服务',
    main_title6_text1: '除遵守本协议约定外，您还需遵守第三方的用户协议及收费规定。我们和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。我们不为第三方软件或技术提供任何客户支持。若您需要支持，需联系第三方服务提供商。您理解并同意，您将与第三方就相应的服务订立合同(下称“第三方协议”)，为保障您的利益，请您在签署第三方协议前仔细读相关协议、政策及业务规则。',
    main_title6_text2: '您在使用前述第三方服务过程中，可能会看到由第三方拥有并控制的网站链接，是否访问这些链接将由您自行决定，我们不就这些链接上的任何信息、数据、观点、图片、陈述或建议的准确性、完整性、充分性、可靠性提供承诺或保证。您应充分理解该等网站的内容及活动，如果您决定访问任何第三方网站链接，其可能带来的结果和法律风险将全部由您自行承担。我们不对任何第三方产品或服务的内容或可用性负责，也不为第三方在本服务中提供的任何内容、广告、产品、服务或其它信息作出任何形式的背书。',
    main_title7: '7.帐号安全',
    main_title7_text1: '您应妥善保管您的Openice帐号用户名与密码、等信息(以下简称为“帐号信息”)，不得与任何人分享此类信息。我们建议您选择安全等级高的密码并妥善保管该密码。您有责任保障您的密码安全。若您将帐号及交易信息细节提供给第三方，由此导致的任何损失与责任应由您自行承担。',
    main_title7_text2: '若您认为有人可能在使用您的帐号，则您应通过“联系我们”章节中的联络信息立即告知我们。您不得使用其他人的Openice帐号使用或访问本服务，由此产生的争议将由您自行承担。您应采取恰当的措施来保护您的帐号及交易信息，避免第三方未经授权使用您的前述信息。',
    main_title8: '8.使用规则',
    main_title8_text1: '您承诺并同意以合法道德的方式依照本协议访问并使用本服务。',
    main_title8_text2: '您不得利用本服务传输任何带有以下性质的内容，或通过其他方式参与、进行任何带有以下性质的活动：',
    main_title8_text2_1: '(a)上传、下载、存储、复制、发布、传输、以电子邮件发送或以其他方式提供如下法律、法规和政策禁止的内容；',
    main_title8_text2_2: '(b)侵害他人隐私权、商业秘密、商标权、著作权、专利权及其他合法权利；',
    main_title8_text2_3: '(c)从事任何不法交易行为，如贩卖枪支、毒品、禁药或其他违禁物；',
    main_title8_text2_4: '(d)计划实施或实施洗钱、套现等非法活动；',
    main_title8_text2_5: '(e)删除本服务内包含的任何版权、商标或其它专有通知；',
    main_title8_text2_6: '(f)复制或更改本服务的全部或部分内容，或允许本服务或其中任何部分与其它任何程序合并或合入其它任何程序；',
    main_title8_text2_7: '(g)未经授权访问或尝试访问或损害本服务或相关系统或网络的任何部分；',
    main_title8_text2_8: '(h)分解、解码或逆向开发本服务或其任一部分，或基于本服务或其任一部分创造衍生作品，或企图从事适用法律禁止的类似活动；',
    main_title8_text2_9: '(i)分发、许可、租赁、出售、转售、转让、公开展示、公开表演、传输、播放、传播或以其它方式使用本服务；',
    main_title8_text2_10: '(j)未经我们事先书面许可，以任何形式将本服务全部或部分内容(包括标的物及源代码)提交或以其它方式提供给任何人；',
    main_title8_text2_11: '(k)冒充他人、伪称或以其它方式虚报您与某人或某实体的关系；',
    main_title8_text2_12: '(I)出于非法目的，以任何不法形式，或违反本协议的方式使用本服务(或其任何部分)，或实施任何欺诈或其它恶意行为，包括但不限于入侵本服务(或本服务链接的网址)或任何操作系统或向其植入恶意代码，包括病毒或有害数据；',
    main_title8_text2_13: '(m)访问和/或使用本服务时侵犯我们或任何第三方的知识产权；',
    main_title8_text2_14: '(n)收集本服务用户的信息，或使用自动化手段来访问本服务或我们系统，或试图通过破译向运行本服务的服务器中传入任何内容或从中提取任何内容；',
    main_title8_text2_15: '(o)开发、支持或使用软件、设备、脚本或任何其它手段或进程(包括爬虫软件、浏览器插件或任何其它技术或人为作业)来攫取本服务或以其它方式从本服务中拷贝用户信息及其它数据；',
    main_title8_text2_16: '(p)未经我们事先书面许可将本服务用于商业用途；',
    main_title8_text2_17: '(q)使用本服务从事任何违法商业交易，比如贩卖军火、毒品、非法物品、盗版软件或其它违禁品；',
    main_title8_text2_18: '(r)提供赌博信息或使用任何手段引诱他人赌博；',
    main_title8_text2_19: '(s)索要他人登录信息或访问他人帐号；',
    main_title8_text2_20: '(t)参与洗钱、套现或传销活动；',
    main_title8_text2_21: '(u)违反本协议(或其中任何部分)，或助推或怂恿此类行为；',
    main_title8_text2_22: '(v)使用本服务时损害、禁用、削弱或危及本服务或其安全，或使其超负荷，干扰其他用户或任何其他方的电脑系统，入侵或未经授权访问本服务或数据；',
    main_title8_text2_23: '(w)其他违反国家法律、法规、规章及政策法令的行为，或其他违反本协议的行为。',
    main_title9: '9.用户内容',
    main_title9_text: '“用户内容”系指用户通过使用本服务形成的信息、内容和材料，如图形、文字、图像、声音、视频、软件和数据文件等。您须单独对任何您或以您帐号的名义进行的上传、下载、发布、通过电子邮件发送、传输、存储的用户内容承担完全责任。由于我们不控制或接触用户内容，因此我们无法确保任何用户内容的准确性、完整性和适当性。您同意因使用其他本服务用户的用户内容而产生的风险，完全由您自行承担风险，我们不为任何您认为庸俗的、令人反感的、不雅或不适当的用户内容承担任何责任。',
    main_title10: '10.隐私与个人信息保护',
    main_title10_text: '我们非常重视您的个人信息和隐私保护。您理解并同意，在您使用本服务的过程中，出于提供本服务所必需的目的或者基于您的同意，我们将根据《Openice隐私协议》处理您的个人信息。为此您需要仔细阅读单独明示的《Openice隐私声明》，以了解我们处理个人信息的目的、方式，处理的个人信息种类，用户权利行使方式和程序以及我们为保护您的个人信息所采取的措施等信息。',
    main_title11: '11.免责声明',
    main_title11_text1: '本服务仅供您个人使用，不得提供给任何第三方使用。您同意，对未经授权使用本服务导致的任何损失，我们及我们关联公司、负责人、董事、员工、承包商、代理、第三方支付服务提供商、合作伙伴、许可方及经销商不承担任何责任。',
    main_title11_text2: '本服务在使用过程中可能会因不可控制的原因在未知时段内中断、延迟或受到干扰。您同意，对前述中断、延迟、干扰或类似故障导致的或与之相关的任何申索，我们不承担任何责任。',
    main_title11_text3: '在适用法律允许的最大范围内，对于您或其他任何人因下列原因无法访问或使用本服务导致的任何损害，我们不承担任何责任。',
    main_title11_text3_1: '(a)我们对系统或软硬件进行维护或升级导致本服务中止或终止；',
    main_title11_text3_2: '(b)非我们拥有或控制的系统或网络通讯延迟或出现故障；',
    main_title11_text3_3: '(c)我们与任何第三方支付服务提供商之间的合同或其它约定中止、取消或终止；',
    main_title11_text3_4: '(d)由于黑客攻击或类似的安全影响导致错误或中断；',
    main_title11_text3_5: '(e)超出我们合理控制的其他原因。',
    main_title11_text4: '本服务按照“现状”和“现有”提供，且不做任何形式的保证或背书。在适用的法律允许的最大范围内，我们未就以下方面承认任何明示或默示的保证、条件或其它协定，也未就此作出任何担保、承诺、声明或保证：',
    main_title11_text4_1: '(a)根据本服务或经由本服务获得的任何内容的完整性、准确性、可靠性或及时性；',
    main_title11_text4_2: '(b)本服务或承载本服务的服务器是否存在缺陷、错误、病毒、漏洞或其它有害元素；',
    main_title11_text4_3: '(c)本服务运营或功能方面的缺陷是否会得到修正；',
    main_title11_text4_4: '(d)与本服务特定功能相关的保证，或您在使用或访问本服务时获得的任何信息是否可靠、优质或准确；',
    main_title11_text4_5: '(e)本服务是否安全无误；',
    main_title11_text4_6: '(f)本服务是否可靠、优质、准确、可用或能够满足您的需求、能够产生特定的结果或实现特定的结果或成果。因全部或部分依赖、使用或诠释本服务，或因您(或其他任何人)访问和/或使用本服务时获得的信息而造成的任何损失或损害，我们不承担任何责任。',
    main_title11_text5: '部分国家的法律不允许合同中排除或限制某些保证、担保或责任。若这些法律适用于您，则前述排除或限制条款的全部或部分可能不适用。本协议中的任何内容均不影响您作为消费者应该享有的法定权利。',
    main_title12: '12.赔偿',
    main_title12_text1: '在您所在司法辖区适用法律允许的最大范围内，您应确保我们免受以下内容引起或与之相关的申索、诉讼或起诉的伤害：',
    main_title12_text1_1: '(1)您的内容；',
    main_title12_text1_2: '(2)您对本服务的使用；',
    main_title12_text1_3: '(3)您违反本协议或适用的最终用户许可协议中的任何部分；',
    main_title12_text1_4: '(4)您侵犯第三方知识产权或其它任何权利；',
    main_title12_text1_5: '(5)任何人使用您的Openice帐号实施的类似行为或违反上述内容。',
    main_title12_text2: '包括因以上情形引发的各项纠纷、投诉、诉讼导致的任何责任、损害、费用、诉讼费及律师费。您保证并同意在任何我们提出合理要求时立即并全力协助进行辩护。',
    main_title13: '13.由您终止',
    main_title13_text1: '您可通过帐户设置或停止使用本服务来终止本协议；',
    main_title13_text2: '您的帐号终止后，我们可以立即、永久地删除任何及所有您帐号下的资料，文件和存储的内容，但基于某些法律和现实的因素，我们可能无法删除这些数据的备份副本。同时，您发送给其他用户的内容，包括消息，也可能无法删除。',
    main_title14: '14.由我们终止或中止',
    main_title14_text1: '我们可能依照适用法律中止、限制、取消或终止您访问全部或部分本服务，而不对任何个人或第三方承担任何责任。我们会在采取前述行动前尽力通知您。但若出现如下情形，我们可能在不事先通知您的情况下立即中止、限制、取消或终止您访问全部或部分本服务：',
    main_title14_text1_1: '(a)您违反或我们有理由认为您即将违反本协议，包括其中包含的任何约定、政策或指南；',
    main_title14_text1_2: '(b)您或代表您行事的任何人进行欺诈或违法活动，或向我们提供虚假或误导信息；',
    main_title14_text1_3: '(c)依照有效法律程序响应执法部门或政府机关提出的要求；',
    main_title14_text1_4: '(d)为执行紧急的系统或硬件维护或更新工作；',
    main_title14_text1_5: '(e)因无法预料的技术、安全或业务原因。',
    main_title14_text2: '本协议的到期或终止不影响本协议中明确说明在其失效或终止后仍可操作或继续有效的条件，也不影响任何应计权益或义务或任何应在本协议失效或终止后继续有效的权利或义务。',
    main_title14_text3: '任何本协议中明示或依其性质应当在协议终止后继续有效的条款，将在本协议终止后继续保持其完整效力，直至这些条款中的条件被满足或者依其性质应当到期为止。',
    main_title15: '15.对本协议的修订',
    main_title15_text1: 'Openice一直在更新、修订和改善本服务。我们可能为本服务增删功能或性能，设置新的限制或临时中止或永久停止提供某项服务；我们也可能基于本服务的更新随时修订本协议。',
    main_title15_text2: '更新后的协议条款一旦公布即代替原来的协议条款，我们会在APP页面上及时发布对本协议的变更。如果您不接受修改后的协议，请立即停止使用本服务，您继续访问或使用本服务即被视为接受修改后的协议。',
    main_title15_text3: '若对本协议的修订会严重影响您或严重限制您对本服务的访问或使用，我们会在变更之前的合理时间内通知您。对于为了满足安全、法律或监管要求而对本服务作出的修订，我们可能无法满足前述的预告时间要求，但我们会尽快通知您。',
    main_title16: '16.适用法律及管辖',
    main_title16_text: '本协议适用法律为中华人民共和国法律。您和我们同意，本协议签订地为中国广东省深圳市宝安区。在合同履行过程中双方如发生纠纷，应协商解决；协商不成的，双方应向协议签订地有管辖权的人民法院以诉讼的方式解决。',
    main_title17: '17.一般条款',
    main_title17_text1: '本服务或第三方可能会提供其它网站或资源的链接。您理解并同意，我们不为此类外部网站或资源的可用性负责，也不对此类网站或资源上，或由此获得的任何内容、广告、产品或其它信息作出任何形式的背书或承担任何责任。因您使用或依赖任何根据或经由此类网站或资源获得的任何内容、商品或服务而导致的或声称由此导致或与之相关的任何损害或损失，我们不承担任何责任。',
    main_title17_text2: '本协议中的任何内容均不得视为在您与我们之间建立了任何合作或代理关系。任何一方无权以另一方的名义或代表另一方产生任何责任债务或成本，或订立任何合同或其它约定。',
    main_title17_text3: '因我们合理控制范围外的事件造成或导致我们未能或延迟履行本协议或本服务条件中的义务，我们不承担任何责任。',
    main_title17_text4: '若本协议中的任何条款被有管辖权的法院或其它任何主管机构视为无效、失效或无法执行，则该条款应视为已从本协议中删除，但其它任何条款仍具有法律效力。',
    main_title18: '18.联系我们',
    main_title18_text1: '如您对本协议有任何疑问，请通过以下地址与我们联系，我们会给予您必要的帮助：',
    main_title18_text2: '云天智能信息（深圳）有限公司',
    main_title18_text3: '地址：深圳市宝安区西乡街道固兴社区航城大道华丰国际机器人福森产业园B栋三层',
    main_title18_text4: `联系电话：18535710511`,
  },
  sdk: {
    Index_title: '第三方SDK列表',
    illustrate: '为保障Openice App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。我们会对SDK或其他类似的应用程序进行严格的安全监测，并要求合作伙伴采取严格的措施来保护您的个人数据。在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK，并及时在本说明中向您公开说明接入第三方SDK的最新情况。请注意，第三方SDK可能因为版本升级、策略调整等原因导致数据类型存在一些变化，请以其公示的官方说明为准。目前本应用接入的第三方SDK如下：',

    SDK_title_1: '第三方SDK名称：',
    SDK_title_2: '第三方公司名称：',
    SDK_title_3: '使用目的：',
    SDK_title_4: '涉及个人信息：',
    SDK_title_5: '隐私协议链接或SDK URL：',

    SDK_name_1: 'QQ互联sdk（Android版本）',
    SDK_company_1: '深圳市腾讯计算机系统有限公司',
    SDK_objective_1: '分享到QQ',
    SDK_information_1: '系统语言，外部存储状态，最近一次地理位置信息，网络位置信息，持续定位，网络类型，手机号码，SIM 卡序列号，网络服务运营商，IMEI，MAC 地址，Android_ID，IP 地址，WiFi 信息，应用安装列表(矢量、加速度、压力、方向、地磁、陀螺、温度、光敏、nema信号)、设备信号强度信息】、设备标识信息(IDFA、0AID)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(设备品牌及型号、操作系统、运营商信息、屏幕分辨率)等。',
    SDK_url_1: 'https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e',

    SDK_name_1_2: '微信OpenSDK Android',
    SDK_company_1_2: '深圳市腾讯计算机系统有限公司',
    SDK_objective_1_2: '微信登录、分享到微信',
    SDK_information_1_2: '系统语言，外部存储状态，最近一次地理位置信息，网络位置信息，持续定位，网络类型，手机号码，SIM 卡序列号，网络服务运营商，IMEI，MAC 地址，Android_ID，IP 地址，WiFi 信息，应用安装列表(矢量、加速度、压力、方向、地磁、陀螺、温度、光敏、nema信号)、设备信号强度信息】、设备标识信息(IDFA、0AID)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(设备品牌及型号、操作系统、运营商信息、屏幕分辨率)等。',
    SDK_url_1_2: 'https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8',

    SDK_name_2: 'Facebook SDK',
    SDK_company_2: 'Meta Platforms, Inc.',
    SDK_objective_2: '使用Facebook分享、登录',
    SDK_information_2: '应用事件、配置数据、错误信息、Facebook 的用户的编号、短期数据。',
    SDK_url_2: 'https://www.facebook.com/privacy/explanation',

    SDK_name_3: '友盟+社会化分享SDK与友盟+移动统计SDK',
    SDK_company_3: '友盟同欣（北京）科技有限公司',
    SDK_objective_3: '用户使用效果统计分析、内容的分享',
    SDK_information_3: '设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID/ICCID、SIM 卡 IMSI 信息）、IP地址、位置、IMSI、Android_ID、获取设备序列号。',
    SDK_url_3: 'https://www.umeng.com/page/policy',

    SDK_name_4: '地图SDK与定位SDK',
    SDK_company_4: '高德软件有限公司',
    SDK_objective_4: '运动地图页面的地图展示，快捷导航，地图导航，历史记录页面轨迹回放，静态地图展示。',
    SDK_information_4: 'IDFA；OAID；应用名；应用版本号；设备品牌及型号；操作系统；运营商信息；屏幕分辨率；IP地址；GNSS信息；网络类型；WiFi状态；WiFi参数；WiFi列表；WiFi信号强度的信息；WiFi网关地址；SSID；BSSID；基站信息；传感器信息（矢量、加速度、压力）；设备信号强度信息；经纬度。',
    SDK_url_4: 'https://lbs.amap.com/pages/privacy/',

    SDK_name_5: 'GoogleSignIn',
    SDK_company_5: 'Alphabet Inc',
    SDK_objective_5: '谷歌账户登录',
    SDK_information_5: '收集的信息包括唯一标识符、浏览器类型和设置、设备类型和设置、操作系统、移动网络信息（包括运营商名称和电话号码）以及应用版本号。我们还会收集您的应用、浏览器和设备同 Google 服务进行互动的相关信息，包括 IP 地址、崩溃报告、系统活动以及相应请求的日期、时间和引荐来源网址。',
    SDK_url_5: 'https://policies.google.com/privacy?hl=zh-CN',

    SDK_name_6: '谷歌地图  SDK',
    SDK_company_6: 'Google Inc',
    SDK_objective_6: '运动地图页面的地图展示，快捷导航，地图导航，历史记录页面轨迹回放，静态地图展示',
    SDK_information_6: 'IDFA；设备品牌及型号；操作系统；运营商信息；屏幕分辨率；IP地址；GNSS信息；网络类型；WiFi状态；WiFi参数；WiFi列表；WiFi信号强度的信息；WiFi网关地址；SSID；BSSID；基站信息；传感器信息（矢量、加速度、压力）；设备信号强度信息；经纬度。',
    SDK_url_6: 'https://policies.google.com/privacy?hl=zh-CN',

    SDK_name_7: '华为机器学习服务--文字图像超分辨率',
    SDK_company_7: '华为软件技术有限公司',
    SDK_objective_7: '对图像进行分割、提供图像超分服务',
    SDK_information_7: '获取相机权限、获取访问网络权限、获取麦克风权限、获取写存储权限、获取读取权限、获取查看网络状态权限、获取查看Wi-Fi网络状态权限',
    SDK_url_7: 'https://developer.huawei.com/consumer/cn/doc/development/hiai-Guides/android-sdk-ys-0000001222765290',

    SDK_name_8: '华为统一扫码SDK（Android版）',
    SDK_company_8: '华为软件技术有限公司',
    SDK_objective_8: '设备绑定扫码',
    SDK_information_8: '读存储（媒体和文件）权限、相机权限、网络权限',
    SDK_url_8: 'https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050043971',
  }
}